// extracted by mini-css-extract-plugin
export default {"content":"BookingDetails_content__jFt20","propertyPhoto":"BookingDetails_propertyPhoto__jB5i6","propertyName":"BookingDetails_propertyName__Q1KAc"};